import { ChangeDetectionStrategy, Component, input, linkedSignal, signal } from '@angular/core';

import {
  QuantityInputComponent,
  ResolvableModal,
  TranslatePipe,
} from '@softline/ui-core';
import { SelectDsComponent, SelectDsOptionComponent } from '@softline/ui-core/select';
import { Certificate } from '@softapps/wws/core';

@Component({
  selector: 'soft-choose-certificate-dialog',
  imports: [
    TranslatePipe,
    SelectDsComponent,
    SelectDsOptionComponent,
    QuantityInputComponent,
  ],
  templateUrl: './choose-certificate-dialog.component.html',
  styleUrls: ['./choose-certificate-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChooseCertificateDialogComponent extends ResolvableModal<{
  certificate: Certificate;
  percentage: number
} | null> {
  readonly possibleCertificates = input.required<Certificate[]>();
  readonly preSelectedCertificate = input<Certificate>();

  readonly selected = linkedSignal(() => {
    return this.preSelectedCertificate() ?? null;
  });

  readonly percentage = signal<number>(0);

  submit() {
    const certificate = this.selected();
    if(!certificate) return;

    this.resolve({
      certificate,
      percentage: this.percentage()
    })
  }
}
